import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useMemo } from "react";
import { IconMap, rootClass } from "./constant.js";
import "./index.css";
function Result(props) {
    const { status = '500', title, description, action, icon, className } = props;
    const iconNode = useMemo(()=>{
        const SVGComponent = IconMap[status] || IconMap.info;
        return /*#__PURE__*/ jsx("div", {
            className: `${className} ${rootClass}-image`,
            children: /*#__PURE__*/ jsx(SVGComponent, {})
        });
    }, [
        status
    ]);
    return /*#__PURE__*/ jsxs("div", {
        className: classnames(className, rootClass),
        children: [
            /*#__PURE__*/ jsx("div", {
                className: classnames(`${rootClass}-icon`, status),
                children: icon || iconNode
            }),
            title && /*#__PURE__*/ jsx("div", {
                className: `${rootClass}-title`,
                children: title
            }),
            description && /*#__PURE__*/ jsx("div", {
                className: `${rootClass}-description`,
                children: description
            }),
            action && /*#__PURE__*/ jsx("div", {
                className: `${rootClass}-action`,
                children: action
            })
        ]
    });
}
export { Result as default };
